import { useState } from 'react';

const WebdesignServices = () => {
  const [activeTab, setActiveTab] = useState('webdesign');

  const services = {
    webdesign: {
      title: 'Webdesign',
      description: 'Moderne und ansprechende Website-Designs, die Ihre Marke perfekt repräsentieren.',
      features: [
        'Responsive Design für alle Geräte',
        'Benutzerfreundliche Navigation',
        'Moderne und zeitgemäße Optik',
        'Corporate Design Integration',
        'Conversion-optimierte Layouts',
        'Barrierefreie Gestaltung'
      ]
    },
    webentwicklung: {
      title: 'Webentwicklung',
      description: 'Technische Umsetzung Ihrer Website mit modernsten Technologien, KI-Unterstützung und bewährten Standards.',
      features: [
        'React, TypeScript, JavaScript',
        'HTML5, CSS3, TailwindCSS',
        'Node.js, Python Backend',
        'KI-gestützte Entwicklung',
        'Content Management Systeme',
        'E-Commerce Lösungen',
        'Datenbank Integration (SQL, NoSQL)',
        'API Entwicklung & Integration',
        'Performance Optimierung',
        'Cloud-Deployment (AWS, Vercel)'
      ]
    },
    wartung: {
      title: 'Wartung & Support',
      description: 'Kontinuierliche Betreuung und Pflege Ihrer Website für optimale Performance.',
      features: [
        'Regelmäßige Updates',
        'Sicherheits-Monitoring',
        'Backup-Service',
        'Performance-Überwachung',
        'Content-Pflege',
        '24/7 Support'
      ]
    }
  };

  return (
    <section className="py-32 bg-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="w-2 h-2 bg-[#d1bc8a] rounded-full"></div>
            <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-light">Services</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 tracking-tight">
            Unsere Webdesign &<br />Entwicklung Services
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto font-light">
            Von der ersten Idee bis zur fertigen Website - wir begleiten Sie durch den gesamten Prozess
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          {/* Tab Navigation */}
          <div className="flex flex-wrap justify-center mb-16 gap-4">
            {Object.entries(services).map(([key, service]) => (
              <button
                key={key}
                onClick={() => setActiveTab(key)}
                className={`px-8 py-3 font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-sm tracking-wider uppercase ${
                  activeTab === key
                    ? 'bg-[#d1bc8a] text-black'
                    : 'bg-zinc-900 text-gray-400 hover:text-white hover:bg-zinc-800'
                }`}
              >
                {service.title}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="bg-zinc-900 border border-zinc-800 p-12 md:p-16">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h3 className="text-4xl font-bold text-white mb-6 tracking-tight">
                  {services[activeTab as keyof typeof services].title}
                </h3>
                <p className="text-lg text-gray-400 mb-10 font-light leading-relaxed">
                  {services[activeTab as keyof typeof services].description}
                </p>
                <div className="grid gap-5">
                  {services[activeTab as keyof typeof services].features.map((feature, index) => (
                    <div key={index} className="flex items-start group">
                      <div className="w-1 h-1 bg-[#d1bc8a] rounded-full mt-2 mr-4 group-hover:scale-150 transition-transform duration-300"></div>
                      <span className="text-gray-300 font-light">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="relative">
                <div className="relative overflow-hidden">
                  <img
                    src={`https://public.readdy.ai/ai/img_res/91e09da782f7c288355787d21488d104.jpg${activeTab}&orientation=landscape`}
                    alt={services[activeTab as keyof typeof services].title}
                    className="w-full h-96 object-cover grayscale hover:grayscale-0 transition-all duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebdesignServices;